// extracted by mini-css-extract-plugin
export var distributors = "ReleaseTemplate-module--distributors--rFbTp";
export var section = "ReleaseTemplate-module--section--gfdRK";
export var subheading = "ReleaseTemplate-module--subheading--GXuLs";